<!-- 密文身份证查看 -->
<template>
  <span class="decrypt" v-if="originVal">
    {{ showEye ? originVal : fechCardData.result.value }}
    <EyeInvisibleTwoTone v-show="showEye" @click="getCardId" class="real-user-show" />
    <EyeTwoTone v-show="!showEye" @click="getCardId" class="real-user-show" />
  </span>
</template>
<script setup lang="ts" name="DecryptIdCard">
  import { ref } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone } from '@ant-design/icons-vue'
  import servicePointAuthService from '@/service/api/auth'
  import { useApi } from '@xinghai/site-common'
  interface Props {
    /**原始数据 */
    originVal: string
    /**去后台换取真是数据秘钥 */
    encryptStr: string
  }
  const props = defineProps<Props>()

  /**查看身份证号 */
  const showEye = ref(true)
  const fechCardData = useApi(servicePointAuthService.getCaptcha)
  const getCardId = () => {
    showEye.value = !showEye.value
    if (!props.encryptStr || fechCardData.loading?.value || fechCardData.result.value || showEye.value) return
    fechCardData.fetchData({ encryptIdNumber: props.encryptStr })
  }
</script>
<style lang="less" scoped>
  .decrypt {
    display: flex;
    align-items: center;
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
